import { type ModuleApiInfo } from "@client/content/selectors";
import { Loading } from "@client/controls/Loading/component";
import { usePromise } from "@client/lib/hooks";
import React from "react";
import api from "../api";
import { type Checkout } from "../types";

export type ParametersProviderChildrenProps = {
  parameters: Checkout.IntegrationParameter[];
};

type Props = {
  apiInfo: ModuleApiInfo;
  integrationId: string;
  children: (props: ParametersProviderChildrenProps) => any;
  shouldRenderImmediately?: boolean;
};

export default (props: Props) => {
  const [resp, isLoading] = usePromise({
    fn: api.getIntegrationParameters,
    args: [props.apiInfo, props.integrationId],
    shouldLoad: true
  });

  if (isLoading && !props.shouldRenderImmediately) return <Loading />;

  return props.children({
    parameters: resp?.response?.data ?? []
  });
};
